<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Asset {{ asset_type?.parent ? 'Subtype' : 'Type' }}</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="px-3 py-4">
  <p>{{ asset_type.name }}</p>

  <h6>Description</h6>
  <p style="white-space: pre-wrap;">{{ asset_type.description }}</p>

  <ng-container *ngIf="asset_type?.parent">
    <h6>Parent Asset Type</h6>
    <p>{{ asset_type.parent.name }}</p>
  </ng-container>

  <ng-container *ngIf="asset_type?.created_by_user">
    <h6>Created By</h6>
    <p>
      <a (click)="onUserPublicView(asset_type.created_by_user.hash)" matTooltip="View User Public Profile">
        {{ asset_type.created_by_user.contact_person }}
      </a>
    </p>
  </ng-container>

  <ng-container *ngIf="asset_type?.date_created">
    <h6>Created At</h6>
    <p>{{ (asset_type.date_created * 1000) | timezoneConvertLong }}</p>
  </ng-container>

  <ng-container *ngIf="asset_type?.updated_by_user">
    <h6>Last Updated By</h6>
    <p>
      <a (click)="onUserPublicView(asset_type.updated_by_user.hash)" matTooltip="View User Public Profile">
        {{ asset_type.updated_by_user.contact_person }}
      </a>
    </p>
  </ng-container>

  <ng-container *ngIf="asset_type?.date_modified">
    <h6>Last Updated At</h6>
    <p>{{ (asset_type.date_modified * 1000) | timezoneConvertLong }}</p>
  </ng-container>
</mat-dialog-content>

